import { render, staticRenderFns } from "./Box18.vue?vue&type=template&id=9479f642&scoped=true&"
import script from "./Box18.vue?vue&type=script&lang=js&"
export * from "./Box18.vue?vue&type=script&lang=js&"
import style0 from "./Box18.vue?vue&type=style&index=0&id=9479f642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9479f642",
  null
  
)

export default component.exports